import { MappingActivityDestination } from 'app/constants/configuration/mappingActivityDestination'

export const getMappingActivityDestinationName = (
  mappingActivityDestination: MappingActivityDestination,
  translate: (string) => string,
): string => {
  const text: string = MappingActivityDestination[mappingActivityDestination]
  return translate(`mappingActivityDestination.${text}`)
}
